import lodash from 'lodash'
import { getItemsBuhtaByConfig } from '/src/utils/getItemsBuhtaByConfig'

export const sliceColoring = {
  id: 'sliceColoring',
  // tName:  'personalizations.sliceColoring.sliceColoring',
  template: 'modal',
  preview: 'edge',

  originPersonalizationsIds: [
    637, // Окраска среза обложки Дуо Флекс 13х21, 15х21, 15.5х21
    658, // Окраска среза обложки Дуо Флекс 10х16, 10.5х16
    659, // Окраска среза обложки Дуо Флекс 20х26, 20.5х27
    660, // Окраска среза обложки Дуо Флекс 33х15
    729, // Выбор цвета окраса среза Метал Флап Лайт
  ],

  getPersConfig,
  getItemsBuhta,
}

/** Формирует массив с выбранными персоналками и моделями
 * (нужно для отображения на 4-м шаге) */
function getPersConfig(store, oldModelValues) {
  const items = []
  const modelValues = {}

  const params = {
    store,
    oldModelValues,
    items,
    modelValues,
    originIdsAvailable: this.originIdsAvailable,
    originPersonalizations: this.originPersonalizations,
  }

  getColor(params)

  return {
    modelValues,
    items: lodash.sortBy(items, ['sort']),
  }
}

/** Формирует массив с выбранными персоналками бухты
 * (нужно для запроса цены) */
function getItemsBuhta({ modelValues }) {
  const originPersonalizations = this.originPersonalizations
  let idBuhta
  const idParam = 100
  const idValue = modelValues?.color?.id

  if (idValue) {
    const selectedPers = [637, 658, 659, 660, 729]
    const idsBuhta = lodash.intersection(this.originIdsAvailable, selectedPers)
    idBuhta = idsBuhta[0]
  }

  return getItemsBuhtaByConfig(originPersonalizations, idBuhta, [
    {
      idParam,
      idValue,
    },
  ])
}

/**
 * Выбор цвета окраса среза
 */
function getColor(params) {
  const { oldModelValues, items, modelValues, originPersonalizations, originIdsAvailable } = params

  const idBuhta = originIdsAvailable[0]
  const idParam = 100

  let values = []
  if (originPersonalizations[idBuhta].params) {
    const val = originPersonalizations[idBuhta].params.find((item) => item.id === idParam)
    if (val?.values?.length) {
      values = val.values.map((n) => ({
        ...n,
        background: n.hex,
      }))
    }
  }

  if (values.length > 0) {
    items.push({
      id: 'color',
      tName: 'personalizations.sliceColoring.color',
      template: 'selectClassicColor',
      sort: 20,
      values,
    })

    if (oldModelValues.color) {
      modelValues.color = values.find((i) => i.id === oldModelValues.color.id) ?? values[0]
    } else {
      modelValues.color = values[0]
    }
  }
}
